import { Injectable } from "@angular/core";

import { Api } from "../api/api";
import { UnreadNum } from "../../models/unread-num";

@Injectable()
export class UnreadNumProvider {
  constructor(public api: Api) {}

  load(): void {
    this.api.get("badges").subscribe(data => {
      UnreadNum.set(data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/unread-num/unread-num.ts